import { render, staticRenderFns } from "./DetailsBook.vue?vue&type=template&id=44d86ae1&scoped=true"
import script from "./DetailsBook.vue?vue&type=script&lang=js"
export * from "./DetailsBook.vue?vue&type=script&lang=js"
import style0 from "./DetailsBook.vue?vue&type=style&index=0&id=44d86ae1&prod&scoped=true&lang=css"
import style1 from "./DetailsBook.vue?vue&type=style&index=1&id=44d86ae1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d86ae1",
  null
  
)

export default component.exports